import { TOGGLE_SIDEBAR } from 'actions/actionTypes'

const initialState = {
  isMenuExpanded: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        isMenuExpanded: !state.isMenuExpanded,
      }

    default:
      return state
  }
}
